<template>
  <draggable
    tag="div"
    :list="list"
    :group="{ name: `depth_${depth}`, put: false }"
    handle=".btnHandle"
    animation="300"
    class="categoryTree">
    <transition-group type="transition"
      tag="div">
      <div
        v-for="item in list"
        :key="checkLimit === 1 ? `${checked[0]}_${item.categoryId}` : item.categoryId"
        :class="{inActive: item.isActive === false}"
        class="item">
        <div class="itemWrap">
          <div class="itemInfo">
            <button
              v-if="item.subCategory && item.subCategory.length"
              type="button"
              class="btnFold"
              @click="foldItem(item.categoryId)"></button>
            <div v-if="collectionItemId && !item.subCategory" class="checkbox">
              <input
                type="checkbox"
                :id="`check_category_${item.categoryId}`"
                :value="item.categoryId"
                name="check_category"
                :checked="isChecked(item.categoryId)"
                @click="changeCheckedItem(item.categoryId, $event)" />
              <label :for="`check_category_${item.categoryId}`"></label>
            </div>
            <SetLanguageValue class="categoryName"
              :locale="locale"
              :langValue="item.categoryLabel"
              :disabled="collectionItemId" />
            <div
              v-if="!collectionItemId"
              class="itemStatus">
              <div v-if="item.subCategory && item.useMain" class="mainStkr" :data-type="item.mainType" :class="{has: item.useMain}">{{ item.mainType === 'image' ? 'M' : 'B' }}</div>
              <div class="imgStkr" :class="{has: item.mainImage}"></div>
            </div>
            <button
              v-if="!collectionItemId"
              type="button"
              class="btnSetting"
              @click="setItem(item.categoryId)"></button>
            <button
              v-if="!collectionItemId"
              type="button"
              class="btnAdd"
              @click="addChildren(item)"></button>
            <button
              v-if="!collectionItemId"
              type="button"
              class="btnDel"
              @click="removeItem(item.categoryId)"></button>
          </div>
          <button
            v-if="!collectionItemId"
            type="button"
            class="btnHandle"></button>
        </div>
        <CollectionCategoryTree
          v-if="item.subCategory && item.subCategory.length && !foldItems.includes(item.categoryId)"
          :locale="locale"
          :list="item.subCategory"
          :defaultLang="defaultLang"
          :depth="depth + 1"
          :collectionItemId="collectionItemId"
          :checked="checked"
          :class="{childrenGroup: depth > 1}"
          @addChildren="addChildren"
          @removeItem="removeItem"
          @setItem="setItem"
          @setLanguage="setLanguage"
          @changeCheckedItem="changeCheckedItem" />
      </div>
    </transition-group>
  </draggable>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'CollectionCategoryTree',
  props: {
    locale: Object,
    collectionItemId: String,
    list: Array,
    defaultLang: String,
    depth: {
      type: Number,
      default: 1,
    },
    checked: {
      type: Array,
      default: () => []
    },
    checkLimit: {
      type: Number,
      default: 1
    }
  },
  components: {
    draggable,
    SetLanguageValue
  },
  computed: {
  },
  created () {
    this.checkedItem = this.checked.map(x => x)
  },
  data () {
    return {
      foldItems: [],
      checkedItem: []
    }
  },
  methods: {
    setLanguage (categoryId, categoryLabel) {
      this.$emit('setLanguage', categoryId, categoryLabel)
    },
    itemClass (item) {
      return this.list.includes(item) ? 'item' : 'childrenItem'
    },
    setItem (categoryId) {
      this.$emit('setItem', categoryId)
    },
    addChildren (item) {
      if (!item.subCategory) {
        this.$set(item, 'subCategory', [])
      }
      item.subCategory.push({
        categoryId: UNIQUE.uniqueId8(),
        categoryLabel: LANG.valueObj(''),
        useMain: false,
        mainType: 'image', // image 또는 banner
        mainImage: '',
      })
    },
    removeItem (categoryId) {
      this.$emit('removeItem', categoryId)
    },
    foldItem (categoryId) {
      function toggleItem(arr, item) {
        const index = arr.indexOf(item)
        if (index !== -1) {
          arr.splice(index, 1)
        } else {
          arr.push(item)
        }
        return arr
      }
      this.foldItems = toggleItem(this.foldItems, categoryId)
    },
    isChecked (categoryId) {
      return this.checkedItem.includes(categoryId)
    },
    changeCheckedItem (categoryId, event) {
      if (this.checkLimit === 1 && this.checked.includes(categoryId)) {
        event.preventDefault()
        return
      } else {
        this.$emit('changeCheckedItem', categoryId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.categoryTree {
  .item {
    margin-bottom: 8px;
    .categoryTree {
      margin-left: 24px;
      .item {
        margin-top: 2px;
        margin-bottom: 0;
      }
    }
  }
  .itemWrap {
    display: flex;
  }
  .btnHandle {
    position: relative;
    width: 36px;
    border: 1px solid $color-lgrey2;
    border-left: none;
    border-radius: 0 4px 4px 0;
    background: $bg-default;
    cursor: move;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/move.png') 50% 50% / 16px no-repeat;
      opacity: 0.2;
    }
  }
  .itemInfo {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 0 0 12px;
    border: 1px solid $color-lgrey2;
    border-radius: 4px 0 0 4px;
    background-color: $color-white;
    button {
      width: 36px;
      height: 36px;
      font-size: 0;
      &:before {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: url('~@/assets/img/ico_arrow.svg') 50% 50% / 16px no-repeat;
        opacity: 0.4;
      }
    }
    .checkbox {
      margin-right: 8px;
      [disabled] + label {
        opacity: 0.6;
      }
    }
    .name {
      flex: 1;
    }
    .btnFold {
      &:before {
        background-image: url('~@/assets/img/ico_arrow.svg');
      }
    }
    .btnSetting {
      margin-right: 4px;
      &:before {
        background-image: url('~@/assets/img/ico_setting.svg');
        background-size: 24px;
      }
    }
    .btnAdd {
      height: 40px;
      border: 1px dashed $color-lgrey2;
      border-radius: 4px;
      background-color: $bg-default;
      &:before {
        background-image: url('~@/assets/img/ico_plus.svg');
        opacity: 0.2;
      }
    }
    .btnDel {
      height: 100%;
      &:before {
        background: url('~@/assets/img/ico_close_black.svg') calc(100% - 8px) 8px / 16px no-repeat;
        opacity: 0.2;
      }
    }
    .categoryName {
      flex: 1;
      margin: 4px;
    }
    .itemStatus {
      display: flex;
      flex-direction: column;
      height: 40px;
      opacity: 0.75;
      .mainStkr {
        width: 20px;
        color: $color-white;
        text-align: center;
        font-size: 10px;
        border-radius: 4px;
        background-color: $color-lgrey;
        &.has {
          background-color: $color-green;
        }
      }
      .imgStkr {
        width: 20px;
        height: 20px;
        margin-top: auto;
        border-radius: 4px;
        background: $color-lgrey url('~@/assets/img/image_wh.png') 50% 50% / 14px no-repeat;
        &.has {
          background-color: $color-green;
        }
      }
      .stkr {
        display: block;
        margin-bottom: 2px;
        padding-left: 4px;
        padding-right: 4px;
        text-align: center;
        font-size: 10px;
        color: $color-white;
        border-radius: 4px;
        background-color: $color-lgrey;
        &.has {
          background-color: $color-green;
        }
      }
    }
  }
  .inActive {
    opacity: 0.4;
    .input {
      color: $color-lgrey;
    }
  }
}
</style>
